import React from 'react';
import {Switch, Route} from 'react-router-dom';

import LayoutRoute from './../utils/LayoutRoute';

import Layout from './Layout';

import Home from './pages/home/index.jsx';
import NotFound404 from './../common_pages/NotFound404';

const ScambRoutes = (props) => (
    <Switch>
        <LayoutRoute layout={Layout} exact path="/" component={Home} />

        <Route path="*">
            <NotFound404 />
        </Route>         
    </Switch>
)

export default ScambRoutes;